import Environment from '@env';

export const API_BASE_URL = Environment.get('apiBaseUrl', '/api');